import axios, { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios';
import { YoukaiArticlesResponse } from '@/youkai/types';

const useGetArticles = async (options: AxiosRequestConfig) =>
  axios(options)
    .then((res: AxiosResponse<YoukaiArticlesResponse>) => {
      const result = res.data;
      return result;
    })
    .catch((error: AxiosError<{ error: string }>) => {
      // eslint-disable-next-line no-console
      console.log(error);
    });

export const useGetYoukaiArticles = async ({ url, offset }: { url: string; offset: number }) => {
  const options = {
    method: 'get',
    url,
    headers: { 'X-WP-Nonce': window.tgwRestApi.nonce },
    params: {
      offset,
      posts_per_page: 4,
    },
  };

  return useGetArticles(options);
};
